export function ago(date: string | Date, referenceDate: string | Date | undefined = undefined): string {
  const MS_PER_SECOND = 1000
  const MS_PER_MINUTE = MS_PER_SECOND * 60
  const MS_PER_HOUR = MS_PER_MINUTE * 60
  const MS_PER_DAY = MS_PER_HOUR * 24
  const MS_PER_MONTH = MS_PER_DAY * 30
  const MS_PER_YEAR = MS_PER_DAY * 365

  if (!date) {
    return ''
  }

  let targetDate: Date
  if (typeof date === 'string') {
    targetDate = new Date(date)
  } else {
    targetDate = date
  }

  let currentDate: Date
  if (referenceDate) {
    if (typeof referenceDate === 'string') {
      currentDate = new Date(referenceDate)
    } else {
      currentDate = referenceDate
    }
  } else {
    currentDate = new Date()
  }

  console.log(`targetDate: ${targetDate}, \ncurrentDate: ${currentDate}`)

  const elapsedMs = currentDate.getTime() - targetDate.getTime()

  if (elapsedMs < MS_PER_MINUTE) {
    const seconds = Math.max(0, Math.floor(elapsedMs / MS_PER_SECOND))
    return formatTime(seconds, 'second') // e.g. "10 seconds ago"
  } else if (elapsedMs < MS_PER_HOUR) {
    const minutes = Math.floor(elapsedMs / MS_PER_MINUTE)
    return formatTime(minutes, 'minute') // e.g. "5 minutes ago"
  } else if (elapsedMs < MS_PER_DAY) {
    const hours = Math.floor(elapsedMs / MS_PER_HOUR)
    return formatTime(hours, 'hour')
  } else if (elapsedMs < MS_PER_MONTH) {
    const days = Math.floor(elapsedMs / MS_PER_DAY)
    return formatTime(days, 'day')
  } else if (elapsedMs < MS_PER_YEAR) {
    const months = Math.floor(elapsedMs / MS_PER_MONTH)
    return formatTime(months, 'month')
  } else {
    const years = Math.floor(elapsedMs / MS_PER_YEAR)
    return formatTime(years, 'year')
  }
}

function formatTime(num: number, timeUnit: string): string {
  const roundedNum = Math.floor(num)
  const pluralSuffix = roundedNum === 1 ? '' : 's'
  return `${roundedNum} ${timeUnit}${pluralSuffix} ago`
}
